import i18next from "i18next";
import moment from "jalali-moment";
import persianJs from "persianjs";
import { useTranslation } from "react-i18next";
export const isEmpty = (value) => {
	try {
		return typeof value === "undefined" || value === null || value === "" || value === "NaN";
	} catch (error) {
		return true;
	}
};
export const isEmptyObject = (value) => {
	try {
		return Object.keys(value).length === 0;
	} catch (error) {
		return true;
	}
};
export const isEmptyArray = (value) => {
	try {
		return Array.isArray(value) && value.length === 0;
	} catch (error) {
		return true;
	}
};
export const convertCurrencyToRial = (value) => {
	try {
		return value * 10;
	} catch (error) {
		return 0;
	}
};
export const convertCurrencyToToman = (value) => {
	try {
		return value / 10;
	} catch (error) {
		return 0;
	}
};
export const commaDigits = (value) => {
	return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
export const complexDigitToman = (value) => {
	try {
		if (!isEmpty(value)) {
			const convertedValue = convertCurrencyToToman(parseInt(value));
			const formattedValue = commaDigits(Math.round(convertedValue));
			return formattedValue;
		}
		return 0;
	} catch (error) {
		return 0;
	}
};
export const complexDigitRial = (value) => {
	try {
		if (!isEmpty(value)) {
			const convertedValue = convertCurrencyToRial(parseInt(value));
			const formattedValue = commaDigits(Math.round(convertedValue));
			return formattedValue;
		} else {
			return 0;
		}
	} catch (error) {
		return 0;
	}
};
export const convertPersian = (value) => {
	try {
		return persianJs(value.toString()).toEnglishNumber();
	} catch (error) {
		return value;
	}
};
export const convertMemory = (value, fromUnit, toUnit) => {
	// تبدیل واحد از ورودی به بایت
	const units = {
		B: 1,
		KB: 1024,
		MB: 1024 * 2,
		GB: 1024 * 3,
		TB: 1024 * 4,
		// اضافه کردن واحدهای دیگر در صورت نیاز
	};

	// بررسی وجود واحدها
	if (!units[fromUnit] || !units[toUnit]) {
		return "Invalid units!";
	}

	// تبدیل به بایت
	const bytes = value * units[fromUnit];

	// تبدیل از بایت به واحد مورد نظر
	return bytes / units[toUnit];

	// console.log(convertBytes(1024, 'kilobyte', 'megabyte')); // خروجی: 1
	// console.log(convertBytes(1, 'gigabyte', 'megabyte')); // خروجی: 1024
	// console.log(convertBytes(1000, 'kilobyte', 'byte')); // خروجی: 1024000
};

export const days_Difference = (fromDate, toDate) => {
	const oneDay = 24 * 60 * 60 * 1000; // تعداد میلی‌ثانیه‌های یک روز

	// تبدیل تاریخ‌ها به شیء تاریخ جاوا اسکریپت
	const dateObject1 = new Date(fromDate);
	const dateObject2 = new Date(toDate);

	// محاسبه تعداد روزهای اختلاف
	const diffDays = Math.round(Math.abs((dateObject1 - dateObject2) / oneDay));

	return diffDays;
};
export const gregorian_to_jalali = (date) => {
	let gregorianDate = moment(date, "YYYY-MM-DD"); // تاریخ میلادی
	let jalaliDate = gregorianDate.format("jYYYY/jMM/jDD"); // تبدیل به تاریخ شمسی
	return jalaliDate;
};
export const currentYear = (_curDate) => {
	return moment(_curDate).format("jYYYY");
};
export const jalali_to_gregorian = (date, split = "-") => {
	let jalaliDate = moment(date, "jYYYY/jMM/jDD"); // تاریخ میلادی
	let gregorianDate = jalaliDate.format(`YYYY${split}MM${split}DD`); // تبدیل به تاریخ شمسی
	return gregorianDate;
};
export const convertToJalaliWithTime = (date, spliter = "/", exportSplit = "/") => {
	try {
		let _tempDate = date?.split("T")[0].split(spliter);
		return gregorian_to_jalali(_tempDate[0] + exportSplit + _tempDate[1] + exportSplit + _tempDate[2]);
	} catch (error) {
		return "";
	}
};
export const convertToJalaliWithoutTime = (date, spliter = "/", exportSplit = "/") => {
	try {
		let _tempDate = date?.split(spliter);
		return gregorian_to_jalali(_tempDate[0] + exportSplit + _tempDate[1] + exportSplit + _tempDate[2]);
	} catch (error) {
		console.error(error, date);
		return "";
	}
};

export const toYMD = (raw, tz = "Asia/Tehran") => {
	if (!raw) return "";
	const s = String(raw).trim();

	// پارسِ دستی برای اطمینان از UTC بودن
	let y,
		m,
		d,
		hh = 0,
		mi = 0,
		ss = 0;

	if (s.includes("-")) {
		// "YYYY-MM-DD" یا "YYYY-MM-DD HH:mm:ss"
		const [date, time] = s.split(/[ T]/);
		const [yy, mm, dd] = (date || "").split("-").map((n) => parseInt(n, 10));
		y = yy;
		m = mm;
		d = dd;
		if (time) {
			const [h, mn, sc] = time.split(":").map((n) => parseInt(n, 10));
			hh = h || 0;
			mi = mn || 0;
			ss = sc || 0;
		}
	} else {
		// "MM/DD/YYYY" یا "MM/DD/YYYY HH:mm:ss"
		const [date, time] = s.split(" ");
		const [mm, dd, yy] = (date || "").split("/").map((n) => parseInt(n, 10));
		y = yy;
		m = mm;
		d = dd;
		if (time) {
			const [h, mn, sc] = time.split(":").map((n) => parseInt(n, 10));
			hh = h || 0;
			mi = mn || 0;
			ss = sc || 0;
		}
	}

	if (!(y && m && d)) return "";

	// لحظه UTC
	const utcMs = Date.UTC(y, m - 1, d, hh, mi, ss);

	// به زمان تهران تبدیل کن و فقط Y-M-D بگیر
	const fmt = new Intl.DateTimeFormat("en-CA", {
		timeZone: tz,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	});
	const parts = Object.fromEntries(fmt.formatToParts(utcMs).map((p) => [p.type, p.value]));
	return `${parts.year}-${parts.month}-${parts.day}`;
};

export const ymdTehranToISO = (ymd, time = "00:00:00", mode = "moment", tz = "Asia/Tehran") => {
	if (!ymd) return "";
	// جداکننده‌ی جنریک
	const parts = String(ymd)
		.trim()
		.split(/[\/-]/)
		.map((x) => x.trim());
	let Y, M, D;
	if (parts.length !== 3) return "";
	// اگر بخش اول 4 رقمه => YYYY-MM-DD، وگرنه MM-DD-YYYY
	if (parts[0].length === 4) [Y, M, D] = parts.map((n) => parseInt(n, 10));
	else [Y, M, D] = [parseInt(parts[2], 10), parseInt(parts[0], 10), parseInt(parts[1], 10)];

	const [h = 0, mi = 0, s = 0] = String(time)
		.split(":")
		.map((n) => parseInt(n, 10));

	// کمک: محاسبه‌ی آفست واقعی تهران در اون لحظه (به دقیقه)
	const offsetOf = (utcMs) => {
		const dtf = new Intl.DateTimeFormat("en-US", {
			timeZone: tz,
			hour12: false,
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		});
		const p = Object.fromEntries(dtf.formatToParts(utcMs).map((x) => [x.type, x.value]));
		const tzMs = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
		return (tzMs - utcMs) / 60000; // دقیقه
	};

	// برای حالت "preserve-day" نیاز داریم آفست روز رو جدا حساب کنیم
	const noonTehranUtcMs = Date.UTC(Y, M - 1, D, 12, 0, 0); // 12:00 به عنوان مبنا
	const noonOffset = offsetOf(noonTehranUtcMs);

	if (mode === "preserve-day") {
		// تاریخ محلی تهران حفظ شود: ISO با آفست (+hh:mm)
		const sign = noonOffset >= 0 ? "+" : "-";
		const abs = Math.abs(noonOffset);
		const oh = String(Math.floor(abs / 60)).padStart(2, "0");
		const om = String(abs % 60).padStart(2, "0");
		const yyyy = String(Y).padStart(4, "0");
		const mm = String(M).padStart(2, "0");
		const dd = String(D).padStart(2, "0");
		return `${yyyy}-${mm}-${dd}T${time}${sign}${oh}:${om}`;
	}

	// mode === "moment": لحظه‌ی واقعی با Z
	const asUTCms = Date.UTC(Y, M - 1, D, h, mi, s); // همان اعداد، به‌عنوان UTC
	const off = offsetOf(asUTCms); // آفست تهران در همان لحظه
	const utcMs = asUTCms - off * 60_000; // تبدیل به UTC واقعی
	return new Date(utcMs).toISOString().replace(".000", "");
};

export const convertToGregorian = (date, spliter = "/", exportSplit = "/") => {
	let _tempDate = date?.split(spliter);
	return jalali_to_gregorian(_tempDate[0] + "/" + _tempDate[1] + "/" + _tempDate[2], exportSplit);
};
export const formatDate = (date) => {
	var d = new Date(date),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;

	return [year, month, day]?.join("-");
};
export const getMinAndMaxDateBirthday = () => {
	let d = new Date();
	let year = d.getFullYear();
	let month = d.getMonth();
	let day = d.getDate();
	let c = new Date(year - 18, month, day);

	var MaxDate = {
		year: parseInt(formatDate(c)),
		month: 11 + 1,
		day: 30,
	};
	c = new Date(year - 100, month, day);
	var MinDate = {
		year: parseInt(formatDate(c)),
		month: month + 1,
		day: day,
	};
	return { MaxDate, MinDate };
};
export function formatMsisdn(msisdn) {
	if (!isEmpty(msisdn)) {
		msisdn = msisdn.toString();
		return msisdn.substr(0, 3) + " " + msisdn.substr(3, 3) + " " + msisdn.substr(6, 2) + " " + msisdn.substr(8, 2);
	} else {
		return "";
	}
}
export const formatString = (template, ...args) => {
	return template.replace(/\{(\d+)\}/g, (match, index) => {
		return args[index] !== undefined ? args[index] : match;
	});
};

export const base64ToFile = (base64String, fileName) => {
	const arr = base64String.split(",");
	const mime = arr[0].match(/:(.*?);/)[1];
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], fileName, { type: mime });
};
export const blobUrlToFile = async (blobUrl, fileName) => {
	const response = await fetch(blobUrl);
	const blob = await response.blob();

	// ساخت یک فایل با استفاده از Blob
	const file = new File([blob], fileName, { type: blob.type });

	return file;
};
export const blobToBase64 = (blob) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result.split(",")[1]); // برش پیشوند Base64
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
};
export const convertBlobToBase64 = async (blobUrl) => {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.responseType = "blob";
		xhr.onload = function () {
			const blob = xhr.response;

			const reader = new FileReader();
			reader.onloadend = function () {
				const base64Data = reader.result.split(",")[1]; // برش پیشوند Base64
				resolve(`data:image/jpeg;base64,${base64Data}`);
			};

			reader.readAsDataURL(blob);
		};

		xhr.onerror = function () {
			reject(new Error("خطا در دریافت Blob"));
		};

		xhr.open("GET", blobUrl);
		xhr.send();
	});
};
export const urltoFile = (url, filename = "newfile.jpg", mimeType = "image/jpeg") => {
	if (url.startsWith("data:")) {
		var arr = url.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[arr.length - 1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		var file = new File([u8arr], filename, { type: mime || mimeType });
		return Promise.resolve(file);
	}
	return fetch(url)
		.then((res) => res.arrayBuffer())
		.then((buf) => new File([buf], filename, { type: mimeType }));
};
export const base64ToImage = async (base64String, filename = "newfile.jpg", mimeType = "image/jpeg") => {
	if (base64String.startsWith("data:")) {
		var arr = base64String.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[arr.length - 1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		var file = new File([u8arr], filename, { type: mime || mimeType });
		return Promise.resolve(file);
	}
	return fetch(base64String)
		.then((res) => res.arrayBuffer())
		.then((buf) => new File([buf], filename + ".jpg", { type: mimeType }));
};

// const convertFileToBase64 = (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result);
//     reader.onerror = reject;
//     reader.readAsDataURL(file);
//   });
// };

export const fileToBase64 = async (input) => {
	try {
		if (!input) return null;

		// dataURL آماده
		if (typeof input === "string") {
			if (input.startsWith("data:")) return input;
			const res = await fetch(input); // blob: یا http(s):
			const blob = await res.blob();
			return await new Promise((resolve, reject) => {
				const r = new FileReader();
				r.onloadend = () => resolve(String(r.result));
				r.onerror = reject;
				r.readAsDataURL(blob);
			});
		}

		// Blob/File مستقیم
		const tag = Object.prototype.toString.call(input);
		const isBlob =
			(typeof Blob !== "undefined" && input instanceof Blob) ||
			tag === "[object File]" ||
			tag === "[object Blob]" ||
			(typeof input.size === "number" && typeof input.type === "string" && typeof input.slice === "function");

		if (isBlob) {
			return await new Promise((resolve, reject) => {
				const r = new FileReader();
				r.onloadend = () => resolve(String(r.result));
				r.onerror = reject;
				r.readAsDataURL(input);
			});
		}

		// رپرهای رایج
		if (typeof input === "object") {
			if (typeof input.preview === "string") return input.preview;
			if (typeof input.url === "string") return await fileToBase64(input.url);
			if (input.originFileObj) return await fileToBase64(input.originFileObj);
			if (input.raw) return await fileToBase64(input.raw);
			if (input.file) return await fileToBase64(input.file);
			if (input.blob) return await fileToBase64(input.blob);
			if (input.photo) return await fileToBase64(input.photo);
		}

		return null;
	} catch {
		return null;
	}
};

export const exportNormalFile = (base64String, isForm = false) => {
	try {
		// تبدیل رشته Base64 به بایت‌ها
		let byteCharacters = atob(base64String.split(",")[1]);
		let byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		let byteArray = new Uint8Array(byteNumbers);

		// ایجاد بلوب از بایت‌ها
		let blob = new Blob([byteArray], { type: "image/jpeg" });

		// بررسی حجم فایل
		if (blob.size > 500 * 1000) {
			// حداکثر حجم 500KB
			// کاهش حجم فایل
			let ratio = (500 * 1000) / blob.size;
			let resizedBlob = blob.slice(0, blob.size * ratio, "image/jpeg");

			// ایجاد فایل جدید از بلوب تغییر یافته
			let file = new File([resizedBlob], "resized_image.jpg", {
				type: "image/jpeg",
			});
			if (isForm) {
				let fd = new FormData();
				fd.append("file", file);
				return fd;
			} else {
				return file;
			}
		} else {
			if (isForm) {
				let fd = new FormData();
				fd.append("file", new File([blob], "original_image.jpg", { type: "image/jpeg" }));
				return fd;
			} else {
				// اگر حجم کمتر از 500KB باشد، فایل اصلی را برگردانید
				return new File([blob], "original_image.jpg", { type: "image/jpeg" });
			}
		}
	} catch (error) {
		console.error(error);
		return fetch(base64String)
			.then((res) => res.arrayBuffer())
			.then((buf) => new File([buf], "original_image.jpg", { type: "image/jpeg" }));
	}
};

export const fileToformData = async (file) => {
	try {
		if (file.size > 0) {
			let formdata = new FormData();
			formdata.append("file", file);
			return formdata;
		} else {
			return null;
		}
	} catch (error) {}
};
export const fileToformDataTest = (input, filenameHint = "upload.bin") => {
	const toFile = (v) => {
		if (!v) return null;

		// اگر آبجکت بود، سعی کن به فایلش برسی
		if (v.file instanceof File || v.file instanceof Blob) return v.file;
		if (v.photo instanceof File || v.photo instanceof Blob) return v.photo;
		if (v instanceof File || v instanceof Blob) return v;

		// اگر base64 DataURL باشه
		if (typeof v === "string" && v.startsWith("data:")) {
			const [head, body] = v.split(",");
			const mime = head.match(/data:(.*?);base64/)?.[1] || "application/octet-stream";
			const bin = atob(body);
			const len = bin.length;
			const bytes = new Uint8Array(len);
			for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
			return new File([bytes], filenameHint, { type: mime });
		}

		return null;
	};

	const file = toFile(input);
	if (!file) return null;

	const fd = new FormData();
	fd.append("file", file, file.name || filenameHint);
	return fd;
};
export const delay = (ms = 3000) => new Promise((resolve) => setTimeout(resolve, ms));
export const deleteAllCookies = () => {
	const cookies = document.cookie.split(";");

	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i];
		const eqPos = cookie.indexOf("=");
		const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
	}
};

export const getFieldDocument = (documentType) => {
	try {
		switch (documentType) {
			case 0:
				return "CertNoCard";
			case 1:
				return "Passport";
			case 2:
				return "PreparednessCard";
			case 3:
				return "RefugeeCard";
			case 4:
				return "IdentityCard";
			case 7:
				return "Fida";
			case 120:
				return "Passport";
			default:
				return "";
		}
	} catch (error) {
		return "";
	}
};
export const getFieldDocumentText = (documentType) => {
	try {
		switch (documentType) {
			case 0:
				return "کارت ملی";
			case 1:
				return "کارت گذرنامه";
			case 2:
				return "کارت امایش";
			case 3:
				return "کارت پناهندگی";
			case 4:
				return "کارت هویت";
			default:
				return "";
		}
	} catch (error) {
		return "";
	}
};
export const formatTime = (time = new Date()) => {
	try {
		let hours = time.getHours();
		let minutes = time.getMinutes();
		let seconds = time.getSeconds();
		return hours + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
	} catch (error) {
		return "";
	}
};

const applyRegex = (value, regexPattern) => {
	const regex = new RegExp(regexPattern, "g");
	return value.replace(regex, "");
};

export const regexFormater = (value) => {
	try {
		if (isEmpty(value)) {
			return "";
		}
		const formatter = {
			value: value,
			applyRegex: (regexPattern) => {
				formatter.value = applyRegex(formatter.value, regexPattern);
				return formatter.value;
			},
			removeSpace: () => {
				return formatter.applyRegex(/\s/g);
			},
			removeComma: () => {
				return formatter.applyRegex(/,/g);
			},
			removeCharacter: (regex) => {
				return formatter.applyRegex(regex);
			},
		};
		return formatter;
	} catch (error) {
		return "";
	}
};

export const ExportDocument = async (_file) => {
	try {
		let container = new DataTransfer();
		let temp = await urltoFile(_file);
		container.items.add(temp);
		let fd = new FormData();
		fd.append("file", container.files[0]);
		return fd;
	} catch (error) {
		return null;
	}
};
export const ExportDocumentFile = async (_file) => {
	try {
		let container = new DataTransfer();
		let temp = await urltoFile(_file);
		container.items.add(temp);
		return container.files[0];
	} catch (error) {
		return null;
	}
};
export const ExportFormDataDocument = async (_file) => {
	try {
		let container = new DataTransfer();
		let temp = await urltoFile(_file);
		container.items.add(temp);
		let fd = new FormData();
		fd.append("file", container.files[0]);
		const fileBlob = new Blob([fd], { type: "application/octet-stream" });
		return fileBlob;
	} catch (error) {
		return null;
	}
};

export const validateInput = ({
	t = null,
	validate = true,
	type = [""],
	min = null,
	max = null,
	length = null,
	typeOfValue = "",
	priceAmount = 0,
	formats = undefined, // ["png","jpeg"] یا ["image/png", ...]
	maxSizeMB = undefined, // مثلا 5 یعنی 5 مگ
}) => {
	const toMimeList = (arr) => {
		if (!arr) return null;
		if (typeof arr === "string") arr = [arr]; // ⬅️ رشته را هم قبول کن
		if (!Array.isArray(arr) || arr.length === 0) return null;
		return arr.map((f) => {
			const s = String(f).toLowerCase().trim();
			if (s.startsWith("image/")) return s;
			const ext = s.replace(/^\./, "");
			const map = {
				jpg: "image/jpeg",
				jpeg: "image/jpeg",
				png: "image/png",
				gif: "image/gif",
				webp: "image/webp",
				bmp: "image/bmp",
				svg: "image/svg+xml",
				heic: "image/heic",
				heif: "image/heif",
				avif: "image/avif",
				tiff: "image/tiff",
			};
			return map[ext] || `image/${ext}`;
		});
	};
	return {
		validator: (rules, value, getFieldValue) => {
			if (type === "image") {
				const file = value; // File/Blob
				if (validate) {
					if (!file || typeof file.size !== "number" || file.size === 0) {
						return Promise.reject(t?.("validation.required") || "پر کردن این فیلد اجباری است");
					}
				}
				const mime = (file?.type || "").toLowerCase();
				const allowed = toMimeList(formats);
				if (allowed && allowed.length > 0) {
					if (!allowed.includes(mime)) {
						return Promise.reject("فرمت فایل مجاز نیست");
					}
				} else {
					if (!mime.startsWith("image/")) {
						return Promise.reject("فرمت فایل مجاز نیست");
					}
				}
				if (typeof maxSizeMB === "number" && maxSizeMB > 0) {
					const maxBytes = maxSizeMB * 1024 * 1024;
					if (file.size > maxBytes) {
						return Promise.reject(`حجم فایل نباید بیش از ${maxSizeMB} مگابایت باشد`);
					}
				}
				return Promise.resolve();
			}
			value = convertPersian(value);
			if (validate) if (isEmpty(value)) return Promise.reject(t("validation.required"));
			if (min !== null) return Promise.reject(formatString(t("validation.minChar"), min));
			if (max !== null) return Promise.reject(formatString(t("validation.maxChar"), max));
			if (length !== null) {
				let _regex = new RegExp(formatString(t("validation.regexDigitLength"), length));
				if (!_regex.test(value)) {
					return Promise.reject(t("validation.regex"));
				}
			}
			if (!isEmpty(type)) {
				if (type === "email") {
					if (!isEmpty(value)) {
						let _regex = new RegExp(t("validation.regexEmail"));
						if (!_regex.test(value)) {
							return Promise.reject(t("validation.regex"));
						}
					}
				}
				if (type === "url") {
					let _regex = new RegExp(t("validation.regexUrl"));
					if (!_regex.test(value)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "number") {
					let _regex = new RegExp(t("validation.regexDigit"));
					if (!_regex.test(value)) {
						return Promise.reject(t("validation.number"));
					}
				}
				if (type === "password") {
					if (value.length <= 8) {
						return Promise.reject(t("validation.minPassword"));
					}
					let _regexChar = new RegExp(t("validation.regexChar"));
					let _regexDigit = new RegExp(t("validation.regexDigit"));
					if (!_regexChar.test(value) || !_regexDigit.test(value)) {
						return Promise.reject(t("validation.complexPassword"));
					}
				}
				if (type === "msisdnOrg") {
					let _regex = new RegExp(t("validation.regexMsisdnOrg"));
					let _val = regexFormater(value.toString()).removeSpace();
					if (!_regex.test(_val)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "msisdn") {
					let _regex = new RegExp(t("validation.regexMsisdn"));
					let _val = regexFormater(value.toString()).removeSpace();
					if (!_regex.test(_val)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "msisdnFix") {
					let _regexFix = new RegExp(t("validation.regexMsisdnFix"));
					let _val = regexFormater(value.toString()).removeSpace();
					if (!_regexFix.test(_val)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "msisdn_global") {
					let _regex = new RegExp(t("validation.regexMsisdnGlobal"));
					let _val = regexFormater(value.toString()).removeSpace();
					if (!_regex.test(_val)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "persian") {
					let _regexFix = new RegExp(t("validation.regexPersian"));
					if (!_regexFix.test(value)) {
						return Promise.reject(t("validation.onlypersian"));
					}
				}
				if (type === "english") {
					let _regexFix = new RegExp(t("validation.regexChar"));
					if (!_regexFix.test(value)) {
						return Promise.reject(t("validation.onlyEnglish"));
					}
				}
				if (type === "passport") {
					let _regexFix = new RegExp(t("validation.regexPassport"));
					if (!_regexFix.test(value)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "charge") {
					let _regex = new RegExp(t("validation.regexDigitComma"));
					if (!_regex.test(value.toString())) {
						return Promise.reject(t("validation.number"));
					}
					let amount = parseInt(regexFormater(value.toString()).removeComma());
					if (
						amount < parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) ||
						amount % parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) !== 0 ||
						amount > parseInt(process.env.REACT_APP_MAX_CHARGE_BANK)
					) {
						return Promise.reject(t("validation.charge"));
					}
				}
				if (type === "chargeWallet") {
					let _regex = new RegExp(t("validation.regexDigitComma"));
					if (!_regex.test(value)) {
						return Promise.reject(t("validation.number"));
					}
					let amount = parseInt(regexFormater(value).removeComma());
					if (amount < parseInt(priceAmount) || amount % parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) !== 0) {
						return Promise.reject(t("validation.chargeWallet"));
					}
				}
				if (type === "image") {
				}
				if (type === "none") {
					return Promise.resolve();
				}
			}
			return Promise.resolve();
		},
		type: typeOfValue,
	};
};

export const SwitchStateMsisdn = (state) => {
	switch (state) {
		case 0:
			return "پیش فعال";
		case 1:
			return "فعال";
		case 2:
			return "قطرنطینه";
		case 100:
			return "آزاد";
		case 101:
			return "رزرو";
		case 102:
			return "قطع دوطرفه";
		case 103:
			return "قطع یک طرفه";
		case 104:
			return "ترمینیت";
		case 105:
			return "قطع دوطرفه حقوقی";
		case 106:
			return "قطع دو طرفه بدلیل مستندات";
		case 107:
			return "قزنطینه برای آکشن";
		case 108:
			return "قرنطینه بدلیل مشکل سمته جی ای سی";
		default:
			return "";
	}
};

export const waitForCaptchaLoad = async () => {
	return "a3f8c2e1-7b4d-4f9a-8e2c-1d6b5a0f3e7c";
};

